import { AnAuditStatuses } from '@/models/Creative'

const getWarningMessage = creative => {
  if (creative.status === 'inactive') {
    return '無効ステータスになってます。配信に利用する場合、クリエイティブ管理から有効化して下さい。'
  } else if (creative.isExpired) {
    return '期限切れとなっています。配信に利用する場合、クリエイティブ管理から有効化して下さい。'
  } else if (creative.anAuditStatus === AnAuditStatuses.REJECTED) {
    return '審査ステータスが却下になってます。クリエイティブの編集する、もしくはサポートまでお問い合わせ下さい。'
  } else {
    return undefined
  }
}

const getWarningMessages = creatives => {
  if (creatives.length === 0) return []
  const messages = []
  if (creatives.map(c => c.status).includes('inactive')) {
    messages.push(
      `・無効ステータスのクリエイティブがあります。
       配信に利用する場合、クリエイティブ管理から有効化して下さい。`,
    )
  }
  if (creatives.map(c => c.isExpired).includes(true)) {
    messages.push(
      `・期限切れとなっているクリエイティブがあります。
       配信に利用する場合、クリエイティブ管理から有効化して下さい。`,
    )
  }
  if (creatives.map(c => c.anAuditStatus).includes(AnAuditStatuses.REJECTED)) {
    messages.push(
      `・審査ステータスが却下となっているクリエイティブがあります。
       クリエイティブの編集する、もしくはサポートまでお問い合わせ下さい。`,
    )
  }
  return messages
}

export default { getWarningMessage, getWarningMessages }
